import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class KitAssemblyDetailService extends DatabaseGwService{

  URL_PATH: string = "/kit-assembly-details";
}
